import { environment } from "../../../environments/environment";
import { deleteAllCookies, getCookie } from "./cookie-utils";



export function sessionTimeout() {
    const tenantCode = getCookie('tenant_code') || '';
    window.location.href = `/${tenantCode}/logout`;
}

